import React from "react";

import { useResortMenuStore } from "../../store/resortMenuStore";
import ResortItems from "../ResortItems";
import { ResortItem } from "../Resorts";

type ResortBodySectionProps = {
  resortsData? : ResortItem[]
};

const ResortBodySection = ({resortsData}: ResortBodySectionProps) => {
    const { selectedDestinationGlobal } = useResortMenuStore()


    return (
      <>
        <section id="resort-body-section">
          <div className="container-nearedge">
            <div className="row">
              <div id="r-body-col" className="col-md-12">
                <section className="section-bread" style={{ textAlign: "left" }}>
                  <ul className="breadcrumb">
                    <li>
                      <a href="#">Home</a>
                    </li>
                    <li className="active">Resorts</li>
                  </ul>
                </section>

                <div className="row">
                  <div className="col-xs-12 col-sm-4 col-md-5 dest-name-wrapper">
                    <div className="top_quote">
                      <p id="dest-name">{selectedDestinationGlobal}</p>
                    </div>
                  </div>
                  <div className="col-xs-12 col-sm-8 col-md-7 filter-col-sorting">
                    <div className="sorting_area">
                      <div className="sort_dropdown">
                        <button className="btn showresortfilters">
                          <i className="fa fa-filter"></i> FILTER
                        </button>
                        <div className="sort-featured-dropdown">
                          SORT:
                          <select id="sorts" className="nice-select-me">
                            <option data-sort-by="sortByFeature">Featured</option>
                            <option data-sort-by="sortAlphabetically" value="1">
                              Alphabetically A-Z{" "}
                            </option>
                            <option data-sort-by="sortByLux_LowHigh" value="2">
                              LT Luxury Rating Low - High{" "}
                            </option>
                            <option data-sort-by="sortByLux_HighLow" value="3">
                              LT Luxury Rating High – Low
                            </option>
                          </select>
                        </div>
                        <div className="sort-view hidden">
                          <span
                            style={{ display: "inline" }}
                            className="visible-xs-inline visible-md-inline visible-lg-inline"
                          >
                            VIEW:
                          </span>

                          <div className="sort-icons">
                            <i className="fa fa-th-large" aria-hidden="true"></i>
                            <i
                              className="fa fa-align-justify"
                              aria-hidden="true"
                            ></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {
              resortsData && <ResortItems resortsData={resortsData} />
            }
          </div>
        </section>
        
    </>
  );
};

export default ResortBodySection;
